import React from 'react'
import { } from 'antd'
import { Button } from 'antd/lib/radio'
export const columns = [
  {
    title: '编号',
    dataIndex: 'goodsSn',
  },
  {
    title: '商品图片',
    dataIndex: 'picUrl',
    render: (url)=>(
      <img src = {url} style = {{width: 100}} alt = "" />
    )
  },
  {
    title: '商品名称',
    dataIndex: 'goodsName',
  },
  //   {
  //     title: '销量',
  //     dataIndex: 'volume',
  //   },
  {
    title: '收藏',
    dataIndex: 'collect',
  },
  {
    title: '分享',
    dataIndex: 'share',
  },
  {
    title: '视频时长',
    dataIndex: 'watchCount',
  },
  {
    title: '视频积分',
    dataIndex: 'watchReward',
  },
  {
    title: '商品时常',
    dataIndex: 'browsCount', // test
  },
  {
    title: '商品积分',
    dataIndex: 'browsReward',
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    render: (status)=>(
      <div>
        <span>{getStatusName(status)}</span>
      </div>
    )
  },
  {
    title: '操作',
    dataIndex: 'opt', 
    render: (text, record, index) => (
      <div>
        <Button onClick = { () => { console.log(record) } }>查看</Button>
        <Button>编辑</Button>
        <Button>日志</Button>
        <Button>删除</Button>
      </div>
    )
  }
]
export function getStatusName (status) {
  status += ''
  switch (status) {
  case ('-2'):
    return {color: 'green', text: '待审核'}
  case ('-1'):
    return {color: 'red', text: '不通过'}
  case ('0'):
    return {color: '#000', text: '通过'}
  case ('1'):
    return {color: 'green', text: '上架中'}
  case ('2'):
    return {color: 'red', text: '已下架'}
  case ('3'):
    return {color: 'red', text: '逻辑删除'}
  default:
    return {color: '', text: '全部商品'}
  }
}